import React, { useState } from "react";
import { Incident, IncidentType, Priority, Severity, Status } from "lib/api";

interface IncidentContextValue {
  incident?: Incident;
  setIncident: (incident: Incident) => void;

  type?: IncidentType;
  setType: (type: IncidentType) => void;

  priority?: Priority;
  setPriority: (type: Priority) => void;

  severity?: Severity;
  setSeverity: (type: Severity) => void;

  status?: Status;
  setStatus: (type: Status) => void;
}

export const IncidentContext = React.createContext<IncidentContextValue>({
  incident: undefined,
  setIncident: () => undefined,
  type: undefined,
  setType: () => undefined,
  priority: undefined,
  setPriority: () => undefined,
  severity: undefined,
  setSeverity: () => undefined,
  status: undefined,
  setStatus: () => undefined,
});

export const IncidentProvider: React.FC = ({ children }) => {
  const [incident, setIncident] = useState<Incident>();
  const [type, setType] = useState<IncidentType>();

  const [priority, setPriority] = useState<Priority>();
  const [severity, setSeverity] = useState<Severity>();
  const [status, setStatus] = useState<Status>();

  return (
    <IncidentContext.Provider
      value={{
        incident,
        setIncident,
        type,
        setType,
        priority,
        setPriority,
        severity,
        setSeverity,
        status,
        setStatus,
      }}
    >
      {children}
    </IncidentContext.Provider>
  );
};
